import { render, staticRenderFns } from "./MassCourseTrainer.vue?vue&type=template&id=65341fa8&scoped=true&"
import script from "./MassCourseTrainer.vue?vue&type=script&lang=js&"
export * from "./MassCourseTrainer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65341fa8",
  null
  
)

export default component.exports